module.exports = __webpack_public_path__ + "static/img/instagram.2c0c9b5c.svg";